import { ISelectType } from "@4uhub/lib4uhub";
import { GlobalAxios } from "../axios/axios-config";

const U_BUS_RELATIONSHIP_TYPE_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusRelationshipType/";

export const uBusRelationshipTypeList = (params?: any) => {
  return GlobalAxios.get<ISelectType[]>(
    U_BUS_RELATIONSHIP_TYPE_ROUTE + "list",
    {
      params: params,
      paramsSerializer: { indexes: null },
    },
  );
};
